import React from 'react';

const LogoElite3E = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#059669"/>
    <path d="M12 14C12 12.8954 12.8954 12 14 12H34C35.1046 12 36 12.8954 36 14V34C36 35.1046 35.1046 36 34 36H14C12.8954 36 12 35.1046 12 34V14Z" fill="white"/>
    <path d="M16 18H24V20H16V18Z" fill="#059669"/>
    <path d="M16 22H32V24H16V22Z" fill="#059669"/>
    <path d="M16 26H28V28H16V26Z" fill="#059669"/>
    <path d="M16 30H24V32H16V30Z" fill="#059669"/>
  </svg>
);

export default LogoElite3E;
